import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getAirwaySelector } from '../selectors'
import { AirwayConstants } from '../store/airway.constants'
import { IAirwayState } from '../store/airway.types'
import { IMultiSelectProps } from '../../../../components/multiSelect/MultiSelect.component'
import { throwPcrException } from '../../../pcr/store/pcr.actions'

export function* setReasonsForFailure() {
  const { inputRows }: IProcedureState = yield select(getProcedureStateSelector)
  const { reasonsForFailure }: IAirwayState = yield select(getAirwaySelector)
  try {
    inputRows.forEach((row) =>
      row.inputs.forEach((input) => {
        if (input.key === AirwayConstants.SET_REASONS_FOR_FAILURE) {
          const props = input.props as IMultiSelectProps
          props.savedValues = reasonsForFailure
        }
      })
    )
    yield put(setInputRows(inputRows))
  } catch (e) {
    yield put(throwPcrException(`setReasonsForFailure() error: ${e}`))
  }
}

export function* setReasonsForFailureSaga() {
  yield takeLatest([AirwayConstants.SET_REASONS_FOR_FAILURE], setReasonsForFailure)
}
